export type FeedbackMode = 'light' | 'dark';

function validMode(value: unknown): FeedbackMode | undefined {
  return value === 'light' || value === 'dark' ? value : undefined;
}

export function savedFeedbackMode(): FeedbackMode | undefined {
  try {
    return validMode(localStorage.getItem('director-feedback-theme'));
  } catch {
    return undefined;
  }
}

// The public board is outside the site's settings provider.
export function inheritedFeedbackMode(): FeedbackMode | undefined {
  const supplied = validMode(new URLSearchParams(window.location.search).get('theme'));
  if (supplied) return supplied;

  try {
    let settings = JSON.parse(localStorage.getItem('settings') || 'null');
    if (typeof settings === 'string') settings = JSON.parse(settings);
    return validMode(settings?.theme?.main?.palette?.mode);
  } catch {
    return undefined;
  }
}

export function feedbackThemeUrl(destination: string, mode: FeedbackMode): string {
  const hashIndex = destination.indexOf('#');
  const hash = hashIndex < 0 ? '' : destination.slice(hashIndex);
  const address = hashIndex < 0 ? destination : destination.slice(0, hashIndex);
  const queryIndex = address.indexOf('?');
  const path = queryIndex < 0 ? address : address.slice(0, queryIndex);
  const query = new URLSearchParams(queryIndex < 0 ? '' : address.slice(queryIndex + 1));
  query.set('theme', mode);
  return `${path}?${query}${hash}`;
}
